
const RX = /^\/api\/public\/media\/([a-f0-9]{32})/;
const WIDTHS = [480, 640, 960, 1280, 1600, 2400];

export const mediaAbs = (url) => (url && url.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

export const mediaSrcSet = (url, fmt) => {
  const m = RX.exec(url || "");
  if (!m) return undefined;
  const mw = Number(new URLSearchParams((url.split("?")[1] || "")).get("mw")) || WIDTHS[WIDTHS.length - 1];
  const ws = [...new Set([...WIDTHS.filter((w) => w < mw), Math.min(mw, WIDTHS[WIDTHS.length - 1])])];
  return ws.map((w) => `${mediaAbs(`/api/public/media/${m[1]}?w=${w}&fmt=${fmt}`)} ${w}w`).join(", ");
};
